import { useRef, useEffect, useCallback } from 'react';

export function useDebouncedCallback(callback, delay) {
    const timeoutRef = useRef();

    const debouncedFn = useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    }, [callback, delay]);

    // Optional: Cancel timeout on unmount
    useEffect(() => {
        console.log('clearing')
        return () => clearTimeout(timeoutRef.current);
    }, []);

    return debouncedFn;
}